var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 200,
    viewBox: "0 0 333 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.136 30.7943C195.184 33.283 225.596 41.5788 245.726 79.1631C261.016 107.701 255.627 143.746 242.487 159.218C210.299 197.155 142.294 195.549 95.1238 154.966C57.8424 122.89 53.2299 84.2899 62.8655 60.6758C73.3224 35.0334 104.444 29.2678 143.136 30.8108V30.7943Z",
    fill: "url(#paint0_linear_967_19658)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.437 138.785L74.3557 171.379C73.5562 171.617 72.7031 171.605 71.9108 171.344C71.1184 171.083 70.4248 170.586 69.9229 169.92C69.421 169.254 69.1348 168.45 69.1026 167.617C69.0705 166.783 69.294 165.96 69.7432 165.257L131.448 68.4404L159.114 102.731L184.437 138.785Z",
    fill: "url(#paint1_linear_967_19658)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.186 138.125C191.4 134.199 183.624 115.077 168.819 95.4157C154.014 75.754 137.785 62.9977 132.571 66.9236C127.357 70.8496 135.133 89.9712 149.938 109.633C164.744 129.295 180.973 142.051 186.186 138.125Z",
    fill: "#CACDD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.447 88.6201C113.325 103.876 133.645 142.709 156.193 145.181",
    stroke: "#FFA8B8",
    strokeWidth: 2.61951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9231 117.498C94.2612 130.701 111.662 156.729 123.425 156.936",
    stroke: "#FFABBB",
    strokeWidth: 2.61951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5891 143.792C80.8432 150.553 88.9523 163.349 95.5932 164.324",
    stroke: "#FFBBC7",
    strokeWidth: 2.61951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.632 39.0401C128.641 39.0401 130.27 37.4114 130.27 35.4024C130.27 33.3933 128.641 31.7646 126.632 31.7646C124.623 31.7646 122.994 33.3933 122.994 35.4024C122.994 37.4114 124.623 39.0401 126.632 39.0401Z",
    stroke: "#F7CA7C",
    strokeWidth: 1.8402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.703 64.3301C172.712 64.3301 174.341 62.7015 174.341 60.6924C174.341 58.6834 172.712 57.0547 170.703 57.0547C168.694 57.0547 167.065 58.6834 167.065 60.6924C167.065 62.7015 168.694 64.3301 170.703 64.3301Z",
    stroke: "#F7CA7C",
    strokeWidth: 1.8402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.816 141.012C203.825 141.012 205.454 139.384 205.454 137.375C205.454 135.365 203.825 133.737 201.816 133.737C199.807 133.737 198.179 135.365 198.179 137.375C198.179 139.384 199.807 141.012 201.816 141.012Z",
    stroke: "#F7CA7C",
    strokeWidth: 1.8402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.824 40.7657C230.833 40.7657 232.462 39.137 232.462 37.128C232.462 35.1189 230.833 33.4902 228.824 33.4902C226.815 33.4902 225.187 35.1189 225.187 37.128C225.187 39.137 226.815 40.7657 228.824 40.7657Z",
    stroke: "#F7CA7C",
    strokeWidth: 1.8402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.518 77.8274C154.099 64.8527 156.124 37.6839 140.374 20.2046",
    stroke: "#FF7C94",
    strokeWidth: 2.29207,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M181.061 120.779C194.749 113.727 217.653 115.341 227.973 125.935",
    stroke: "#FE869C",
    strokeWidth: 2.29207,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.15 84.0284C219.748 70.5145 237.559 70.9293 251.542 74.4509",
    stroke: "#FF7C94",
    strokeWidth: 2.29207,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M183.649 98.741L173.399 95.9038L182.164 90.9429L183.649 98.741Z",
    fill: "#F7CA7C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M240.04 103.279C242.049 103.279 243.678 101.65 243.678 99.6411C243.678 97.6321 242.049 96.0034 240.04 96.0034C238.031 96.0034 236.402 97.6321 236.402 99.6411C236.402 101.65 238.031 103.279 240.04 103.279Z",
    stroke: "#F7CA7C",
    strokeWidth: 1.8402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M175.843 45.7517L178.51 35.4565L183.62 44.134L175.843 45.7517Z",
    fill: "#F7CA7C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M229.849 156.252L223.461 147.749L233.428 149.163L229.849 156.252Z",
    fill: "#F7CA7C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M272.937 95.6302L263.219 95.8252L272.191 89.6738L272.937 95.6302Z",
    fill: "#F7CA7C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_967_19658",
    x1: -12.9252,
    y1: 287.973,
    x2: 171.404,
    y2: 87.7783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.577493,
    stopColor: "#F5E8FF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FDEEFF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#CBE0FF",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_967_19658",
    x1: 87.3511,
    y1: 85.2644,
    x2: 127.042,
    y2: 154.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00456628,
    stopColor: "#88CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#817FEA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTada);
export default __webpack_public_path__ + "static/media/tada.56178758.svg";
export { ForwardRef as ReactComponent };